import { settlementConstants as constants } from "../../constants/settlement";

const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  selectedData: [],
  isError: null,
  error: "",
};

const bankSettlementReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ALL_BANKING :
      return {
        ...state,
        isError: false,
        allData: action.data,
        total: action.data.count
      };
    case constants.GET_BANKING_SUCCESS:
      return {
        ...state,
        isError: false,
        data: action.data,
        total: action.data.count
      };

        case constants.INSERT_BANKING_SUCCESS:
      return {
        ...state,
        isError: false,
        error: ""
      };

    case constants.SELECTED_BANKING:
      return {
        ...state,
        isError: false,
        selectedData: action.data
      }

    case constants.GET_BANKING_FAILURE:
      return { ...state, isError: true, error: action.error };

    case constants.INSERT_BANKING_FAILURE:
      return { ...state, isError: true, error: action.error };


    case constants.CLEAR_DATA:
      return { ...state, isError: null, error: "", selectedData: null };

    default:
      return { ...state };
  }
};
export default bankSettlementReducer;
